import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddToList = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18.2 18.2",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M17.1 8H10.2V1.10004C10.2 0.490037 9.71 0 9.1 0C8.49 0 8 0.490037 8 1.10004V8H1.1C0.49 8 0 8.49004 0 9.10004C0 9.71004 0.49 10.2 1.1 10.2H8V17.1C8 17.71 8.49 18.2 9.1 18.2C9.71 18.2 10.2 17.71 10.2 17.1V10.2H17.1C17.71 10.2 18.2 9.71004 18.2 9.10004C18.2 8.49004 17.71 8 17.1 8Z"
	})
});
export { SvgAddToList as ReactComponent };
